import { Link } from 'react-router-dom';
import appointDocLogo from '../assets/appointdoc-logo-access.png';

export default function ForgotPassword() {
  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center p-4 bg-gray-50/50">
      <div className="w-full max-w-[400px]">
        <div className="text-center">
          <Link to="/">
            <img
              src={appointDocLogo}
              alt="AppointDoc"
              className="w-32 h-auto mx-auto mb-4"
            />
          </Link>
        </div>

        <div className="border border-gray-300 rounded-2xl p-8 bg-white">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-semibold mb-2">Reset your password</h1>
            <p className="text-sm text-muted-foreground">
              Enter your email address and we'll send you instructions to reset
              your password
            </p>
          </div>

          <form className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="email" className="text-sm font-medium">
                Email address
              </label>
              <input
                id="email"
                type="email"
                placeholder="name@example.com"
                className="w-full h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                required
              />
            </div>

            <button
              type="submit"
              className="w-full btn bg-primary-500 hover:bg-primary-600 text-white h-12"
            >
              Send reset instructions
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              Remember your password?{' '}
              <Link
                to="/login"
                className="text-primary-500 hover:text-primary-600 font-medium"
              >
                Back to login
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
